import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  border: none;\n  transition: all 0.3s linear;\n\n  text-transform: uppercase;\n\n  background-color: ",
        ";\n  color: ",
        ";\n  letter-spacing: ",
        ";\n\n  &:disabled {\n    color: ",
        ";\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "styled-components";
var ThemedButton = styled.button(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.button.enabled.backgroundColor;
}, function(param) {
    var theme = param.theme;
    return theme.button.enabled.color;
}, function(param) {
    var theme = param.theme;
    return theme.button.enabled.letterSpacing;
}, function(param) {
    var theme = param.theme;
    return theme.button.disabled.color;
}, function(param) {
    var theme = param.theme;
    return theme.button.disabled.backgroundColor;
});
export default ThemedButton;
